export default function(instance) {
    return {
        login(data) {
            return instance.post('/login', data);
        },
    };
}